export const getDefenceReadinessItems = (items, page, perPage = 10) => {
  const total = items.length

  if (total <= perPage) {
    // case: 10 or fewer → show all, no paging
    return items
  }

  if (total > perPage && total < 2 * perPage) {
    // case: 11–19 → page 1 is 1–10, page 2 is last 10
    if (page === 1) {
      return items.slice(0, perPage)
    } else if (page === 2) {
      return items.slice(total - perPage)
    }
  } else {
    // case: 20+ → standard paging
    const start = (page - 1) * perPage
    return items.slice(start, start + perPage)
  }

  return []
}

// export const getDefenceReadinessPagination = (items, page, perPage = 10) => {
//   const total = items.length

//   // Case: 10 or fewer → show all, no paging
//   if (total <= perPage) {
//     return {
//       items,
//       days: items.map((_, i) => i + 1)
//     }
//   }

//   // Case: 11–19 → overlap paging
//   if (total > perPage && total < 2 * perPage) {
//     if (page === 1) {
//       const slice = items.slice(0, perPage)
//       return {
//         items: slice,
//         days : slice.map((_, i) => i + 1) // 1–10
//       }
//     } else if (page === 2) {
//       const slice = items.slice(total - perPage)
//       return {
//         items: slice,
//         days : slice.map((_, i) => total - perPage + i + 1) // e.g. 6–15
//       }
//     }
//   }

//   // Case: 20+ → normal paging
//   const start = (page - 1) * perPage
//   const slice = items.slice(start, start + perPage)
//   return {
//     items: slice,
//     days : slice.map((_, i) => start + i + 1) // e.g. 11–20
//   }
// }

export const getDefenceReadinessPagination = (items, page, perPage = 10) => {
  const total = items.length
  let totalPages = 1
  let slice = []
  let days = []

  if (total <= perPage) {
    // Case: 10 or fewer → show all, no paging
    slice = items
    days = items.map((_, i) => i + 1)
    totalPages = 1
  } else if (total > perPage && total < 2 * perPage) {
    // Case: 11–19 → overlap paging (2 pages max)
    totalPages = 2
    if (page === 1) {
      slice = items.slice(0, perPage)
      days = slice.map((_, i) => i + 1) // 1–10
    } else if (page === 2) {
      slice = items.slice(total - perPage)
      days = slice.map((_, i) => total - perPage + i + 1) // e.g. 6–15
    }
  } else {
    // Case: 20+ → normal paging
    totalPages = Math.ceil(total / perPage)
    const start = (page - 1) * perPage
    slice = items.slice(start, start + perPage)
    days = slice.map((_, i) => start + i + 1) // e.g. 11–20
  }

  return {
    items  : slice,
    days,
    totalPages,
    maxPage: totalPages
  }
}
